<template>
<div id="ServiceType">
  <b-modal id="modal-1"  v-model="showModal" centered   no-close-on-backdrop hide-header-close
    ok-variant cancel-variant hide-footer
    header-class="PopUpHeader" 
    :body-bg-variant=PopUpVar.bodyBgVariant
    :body-text-variant=PopUpVar.bodyTextVariant
    :footer-bg-variant=PopUpVar.footerBgVariant
    :footer-text-variant=PopUpVar.footerTextVariant>
    <template slot="modal-header"> 
      <div  style="margin: 0 auto;">
        <small class="PopUpTitle w-100 text-center">{{mTitle}}</small>
      </div> 
    </template>
    <ServiceTypeAddEdit v-if="showModal == true" @finished="closeModal" :action="Action" :ServiceTypeData="serviceTypeData" :IsCopy="isCopy" :AllowEdit="popUpAllowEdit"></ServiceTypeAddEdit>
    <div slot="modal-footer" class="w-100"></div>
  </b-modal> 
  
<Subtitle  v-bind:ServiceID="this.AppServiceID">
<template v-slot:header>
<i class="fab fa-sourcetree"></i><b> Manage Service Type Standard:</b>
</template> 
</Subtitle> 
    <Card>
      <CardBody>
        <p>Manage Service Type is an Administration action. Any change in this section will affect the web application and its access level. All transactions are monitored, logged and reviewed.
        </p> 
      </CardBody>
    </Card> 
    <v-client-table :columns="columns" :data="tableData" :options="options">
      <template slot="status" slot-scope="props">
         <span>{{ props.row.status }}</span>
      </template>
      <span class="pointer" v-on:click="EditServiceTypePopup(props.row)" slot="edit" slot-scope="props" 
        v-show="props.row.canEdit == 1"><i class="far fa-edit"></i></span>     
      <span class="pointer" v-on:click="CloneServiceTypePopup(props.row)" slot="clone" slot-scope="props" 
        v-show="props.row.canClone == 1"><i class="fas fa-copy"></i></span>            
      <span class="pointer" v-on:click="ViewServiceTypePopup(props.row)" slot="view" slot-scope="props"><i class="far fa-question-circle"></i></span>        
    </v-client-table>
</div>
</template>
<script>
//import VSelect from '@alfsnd/vue-bootstrap-select'
import {mapGetters} from 'vuex'
import axios from 'axios'
import Vue from 'vue';
import moment from 'moment'
import Modal from '../../../Common/ModelPop.vue';
import ServiceTypeAddEdit from '@/components/DPEBB/Administrator/ServiceTypeAddEdit.vue';
import { PopUpVariant } from '@/Common/Default/PopUpVariant'
import Card from "@/Common/Card.vue";
import CardBody from "@/Common/CardBody.vue";
import TileNote from "@/Common/TileNote.vue";
import Subtitle from '@/Common/Default/SubTitle.vue';  
export default {
  props: {
    AllowEdit: {type: Boolean, required: true},
     
  },
  methods: {
    SetServiceTypeData(row){
      console.log('max clean ' + row.nummaxclean)
      this.serviceTypeData = {
        
        servicetypeid: row.servicetypeid,
        subtypeid1: row.subtypeid1,
        subtypeid2: row.subtypeid2,
        subtypeid3: row.subtypeid3,
        subtypeid4: row.subtypeid4,
        subtypeid5: row.subtypeid5,
        subtypeid6: row.subtypeid6,
        subtypeid7: row.subtypeid7,
        subtypeid8: row.subtypeid8,
        description: row.description,
        effectivedate: row.effectivedate,
        expirydate: row.expirydate,
        codeunitmaxback: row.codeunitmaxback,
        nummaxback: row.nummaxback,
        nummaxgraphs: row.nummaxgraphs,
        
        nummaxclean: row.nummaxclean,
        maxbacktext: row.maxbacktext,
        status: row.status,
        createdby: row.createdby,
        createddate: row.createddate,
        lastmodifiedby: row.lastmodifiedby,
        lastmodifieddate: row.lastmodifieddate,
        dbkey: row.dbkey,
        serviceid: row.serviceid,
        codeprogedc1: row.codeprogedc1,
        codeprogedc2: row.codeprogedc2,
        codeprogedc3: row.codeprogedc3,
        codeprogedc4: row.codeprogedc4,
        codeprogedc5: row.codeprogedc5,
      }
    },
    GoBack(){
      this.$router.push('/DPEBB/MainHome')
    },
    ServiceTypeAddEditPopup(){
        this.showModal = true;
    },
    closeModal() {
      this.isModalVisible = false;
      this.loadTable();
    },
    loadTable() {
      this.showModal = false;
      var vm = this;
      axios.get('/SaskHealthApi/Codes/GetAllServiceTypes?_='+Date.now(), { headers: { 'Authorization': 'Bearer ' + localStorage.access_token }})
        .then(function (response) {
            vm.tableData=response.data;
            }
        )
        .catch(function (er) {
            console.log(er)
          }        
        );
    },
    EditServiceTypePopup(Rowdata){ 
      this.Action ="EDIT";
      this.SetServiceTypeData(Rowdata); 
      this.popUpAllowEdit = this.AllowEdit;
      this.mTitle = this.updateMessage;
      this.isCopy = false; 
      this.showModal = true;
    },
    CloneServiceTypePopup(Rowdata){ 
      this.Action ="ADD";
      this.SetServiceTypeData(Rowdata); 
      this.popUpAllowEdit = this.AllowEdit;
      this.mTitle = this.newMessage;
      this.isCopy = true; 
      this.showModal = true;
    },
    ViewServiceTypePopup(Rowdata){ 
      this.SetServiceTypeData(Rowdata); 
      this.popUpAllowEdit = false;
      this.mTitle = this.viewMessage;
      this.isCopy = false; 
      this.showModal = true;
    },
  },
    
  components: {
        Modal:Modal,
        ServiceTypeAddEdit:ServiceTypeAddEdit,
        Card,
        CardBody,
        TileNote,
        //VSelect,
        Subtitle
  },

  computed:{
      UserName(){
        return !this.$store.getters.GetCurrentUser ? false : this.$store.getters.GetCurrentUser;
      }, 
      AllAppLevel(){
        return this.$store.getters.GetAllApplevel;
      },
  },

  data: function () {
    return {
   
      viewOnly: false,
      AppServiceID:6,
      Action :'',
      popUpAllowEdit: false,
      updateMessage:'Edit Service Type Standard',
      newMessage: 'Add New (Cloned) Service Type Standard',
      viewMessage: 'Viewing Service Type Standard',
      mTitle: '',
      isModalVisible: true,
      showModal: false,
      PopUpVar:PopUpVariant,
      columns: ['status','view' , 'edit', 'clone', 'description','effectivedate','expirydate', 'maxbacktext', 'nummaxgraphs','nummaxclean'],
      tableData: [],
      serviceTypeData: "",
      isCopy: false,
      options: {
        texts:{
            count:"Showing {from} to {to} of {count} records|{count} records|One record",
            first:'First',
            last:'Last',
            filter:"Search Service Type Standard:",
            filterPlaceholder:"Search in table",
            limit:"Records:",
            page:"Page:",
            noResults:"No matching records",
            filterBy:"Filter by {column}",
            loading:'Loading...',
            defaultOption:'Select {column}',
            columns:'Columns'
        },
        responseAdapter({data}) {
            return {
              data: formatData,
              count: data.length
            };
        },
        perPage:10,
        perPageValues:[10,15,25],
        dateColumns:['expirydate','effectivedate'],
        templates: {
          expirydate(h, row) {             
            return moment(row.expirydate,"YYYY-MM-DD").format('YYYY/MM/DD');  
          },
          effectivedate(h, row) {        
            return moment(row.effectivedate,"YYYY-MM-DD").format('YYYY/MM/DD');  
          },
  
        },
        headings: {
          edit: 'Edit',
          clone: '',
          view: 'View',
          description: 'Description',
          status: 'Status',
          effectivedate: 'Effective Date',
          expirydate: 'Expiry Date',
          maxbacktext: 'Max Back Dating Period',
          nummaxgraphs: 'Max Radiograph',
          nummaxclean:'Max Cleaning'
        },
        pagination: {
          edge: true,
          nav: 'scroll',
          chunk: 5
        },
        sortable: ['status','description', 'effectivedate', 'expirydate', 'status', 'maxbacktext', 'nummaxgraphs'],
        filterable: ['status','description'], 
        sortIcon: {
                base : 'fas',
                is: 'fa-sort',
                up: 'fa-sort-up',
                down: 'fa-sort-down'
        },     
      }
    }
  },
 mounted: function () {
     this.$nextTick(function () {
       var vm = this; 
      })
  },
  created () {

      this.loadTable();  
  },
  mounted () {    
    this.viewOnly = !(this.AllowEdit);
    this.popUpAllowEdit = this.AllowEdit;
    if (this.viewOnly)
    {
      var i;
      for (i = 0; i < this.columns.length; i++)
      {
        //remove the edit and clone columns entirely, this user can only view
        if (this.columns[i].toUpperCase() == "EDIT" || this.columns[i].toUpperCase() == "CLONE")
        {
          this.columns.splice(i, 1);
          i--;
        }
      }
    }
  }
}

</script>
 <style lang="scss" scoped>

.fa-times-circle {
  color: red;
}

.fa-check-circle {
  color:green;
}
</style>